module.exports = __webpack_public_path__ + "static/img/yytx20.ee9c184.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx20.png
// module id = 799
// module chunks = 0